import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
    selector: 'grey-card',
    template: `
<ng-content></ng-content>
`,
    styles: [`
  :host { background: var(--contentbg); padding: 5px 10px; border-radius: 6px; border: 1px solid var(--contentbgoutline); }
`],
    standalone: true,
    imports: [CommonModule],
})
export class GreyCardComponent {}